

const __request = require(`./__request/__request_contentType_json`);

// 火车票平台改签单详情接口地址：http://219.128.52.2:9901/doc.html#/trains/order-controller/platformChangeOrderDetailUsingPOST_1

export default function trains_order_platformChangeOrderDetail(pParameter) {
  if (!pParameter) pParameter = {};
  let params = {}
  params.method = 'POST'
  params.urlSuffix = '/trains/order/platformChangeOrderDetail'
  params.data = pParameter;
  params.process_response_data = false
  return new Promise(function (resolve, reject) {
    resolve(__request(params))
  })
}
